// extracted by mini-css-extract-plugin
export default {"inlineAdWrapper":"FR-z","inlineTitle":"GR-z","sponsoredAdsWrapper":"HR-z","marketplaceRecosWrapper":"IR-z"};